export const MESSAGES_ROOT = 'messages/';

// Actions types
export const GET_MESSAGES_BY_CUSTOMER = 'listMessagesByCustomer';
export const GET_MESSAGES_ALL_OFFICE_LIST = 'getOfficesByCustomer';
export const CREATE_MESSAGE = 'createMessage';
export const DELETE_MESSAGES = 'deleteMessages';
export const UPDATE_MESSAGE = 'updateMessage';

// Mutations types
export const SET_MESSAGES_BY_CUSTOMER = 'setMessagesByCustomer';
export const SET_MESSAGES_BY_CUSTOMER_ERRORS = 'setMessagesByCustomerErrors';
export const SET_MESSAGES_ALL_OFFICE_LIST = 'setMessagesAllOfficeList';
export const SET_OPEN_CREATE_MESSAGE_MODAL = 'setOpenCreateMessageModal';
export const SET_OPEN_CREATE_MESSAGE_MODAL_ERRORS = 'setOpenCreateMessageModalErrors';
export const SET_OPEN_DELETE_MESSAGES_MODAL = 'setOpenDeleteMessagesModal';
export const SET_OPEN_DELETE_MESSAGES_MODAL_ERRORS = 'setOpenDeleteMessagesModalErrors';
export const SET_MESSAGES_LOADING = 'setMessagesLoading';
export const MESSAGES_RESET_STATE = 'messagesResetState';

// Getters types
export const MESSAGES_BY_CUSTOMER = 'messagesByCustomer';
export const MESSAGES_BY_CUSTOMER_ERRORS = 'messagesByCustomerErrors';
export const MESSAGES_ALL_OFFICE_LIST = 'messagesAllOfficeList';
export const OPEN_CREATE_MESSAGE_MODAL = 'openCreateMessageModal';
export const OPEN_CREATE_MESSAGE_MODAL_ERRORS = 'openCreateMessageModalErrors';
export const OPEN_DELETE_MESSAGES_MODAL = 'openDeleteMessagesModal';
export const OPEN_DELETE_MESSAGES_MODAL_ERRORS = 'openDeleteMessagesModalErrors';
export const MESSAGES_LOADING = 'messagesLoading';
